
export const CHUC_NANG_PERMISSION_CODES = {
    // tài khoản
    WEB_USER_COMMON: 'WEB_USER_COMMON',

    // Khách hàng
    WEB_CUSTOMER_LIST: 'WEB_CUSTOMER_LIST',
    WEB_CUSTOMER_DETAIL: 'WEB_CUSTOMER_DETAIL',
    WEB_CUSTOMER_ADD: 'WEB_CUSTOMER_ADD',
    WEB_CUSTOMER_EDIT: 'WEB_CUSTOMER_EDIT',
    WEB_CUSTOMER_IMPORT: 'WEB_CUSTOMER_IMPORT',
    WEB_CUSTOMER_EXPORT: 'WEB_CUSTOMER_EXPORT',

    // Danh mục sản phẩm
    WEB_CATEGORY_LIST: 'WEB_CATEGORY_LIST',
    WEB_CATEGORY_DETAIL: 'WEB_CATEGORY_DETAIL',
    WEB_CATEGORY_ADD: 'WEB_CATEGORY_ADD',
    WEB_CATEGORY_EDIT: 'WEB_CATEGORY_EDIT',
    WEB_CATEGORY_IMPORT: 'WEB_CATEGORY_IMPORT',
    WEB_CATEGORY_EXPORT: 'WEB_CATEGORY_EXPORT',

    // Sản phẩm
    WEB_PRODUCT_LIST: 'WEB_PRODUCT_LIST',
    WEB_PRODUCT_DETAIL: 'WEB_PRODUCT_DETAIL',
    WEB_PRODUCT_ADD: 'WEB_PRODUCT_ADD',
    WEB_PRODUCT_EDIT: 'WEB_PRODUCT_EDIT',
    WEB_PRODUCT_IMPORT: 'WEB_PRODUCT_IMPORT',
    WEB_PRODUCT_EXPORT: 'WEB_PRODUCT_EXPORT',

    // phân công đơn hàng
    WEB_ORDER_ASSIGN_PICKER: 'WEB_ORDER_ASSIGN_PICKER',
    WEB_ORDER_ASSIGN_PACKER: 'WEB_ORDER_ASSIGN_PACKER',
    WEB_ORDER_ASSIGN_SHIPPER: 'WEB_ORDER_ASSIGN_SHIPPER',
    /** Tab Gán nhân viên — lọc danh sách toàn chi nhánh (API filter-don-hang-all-branch) */
    WEB_ORDER_ASSIGN_ALL_BRANCH: 'WEB_ORDER_ASSIGN_ALL_BRANCH',

    // nhặt hàng
    WEB_ORDER_PICK_DETAIL: 'WEB_ORDER_PICK_DETAIL',
    WEB_ORDER_PICK_UPDATE: 'WEB_ORDER_PICK_UPDATE',
    WEB_ORDER_PICK_DELETE: 'WEB_ORDER_PICK_DELETE',
    /** Tab Nhặt hàng — lọc danh sách toàn chi nhánh (API filter-don-hang-all-branch) */
    WEB_ORDER_PICK_ALL_BRANCH: 'WEB_ORDER_PICK_ALL_BRANCH',
    /** Tab Nhặt — chip «Mới» + phạm vi lọc tùy chọn (đồng bộ mobile) */
    WEB_PROMPT_CONTINUE_TO_NEXT_STEP: 'WEB_PROMPT_CONTINUE_TO_NEXT_STEP',

    // kiểm tra đơn hàng
    WEB_ORDER_CHECK_DETAIL: 'WEB_ORDER_CHECK_DETAIL',
    WEB_ORDER_CHECK_UPDATE: 'WEB_ORDER_CHECK_UPDATE',
    WEB_ORDER_CHECK_DELETE: 'WEB_ORDER_CHECK_DELETE',
    /** Tab Kiểm hàng — lọc danh sách toàn chi nhánh */
    WEB_ORDER_CHECK_ALL_BRANCH: 'WEB_ORDER_CHECK_ALL_BRANCH',

    // đóng gói đơn hàng
    WEB_ORDER_PACK_DETAIL: 'WEB_ORDER_PACK_DETAIL',
    WEB_ORDER_PACK_UPDATE: 'WEB_ORDER_PACK_UPDATE',
    WEB_ORDER_PACK_DELETE: 'WEB_ORDER_PACK_DELETE',
    /** Tab Đóng hàng — lọc danh sách toàn chi nhánh */
    WEB_ORDER_PACK_ALL_BRANCH: 'WEB_ORDER_PACK_ALL_BRANCH',

    // điều phối đơn hàng
    WEB_ORDER_SCHEDULE_DETAIL: 'WEB_ORDER_SCHEDULE_DETAIL',
    WEB_ORDER_SCHEDULE_UPDATE: 'WEB_ORDER_SCHEDULE_UPDATE',
    WEB_ORDER_SCHEDULE_DELETE: 'WEB_ORDER_SCHEDULE_DELETE',
    /** Tab Điều phối — lọc danh sách toàn chi nhánh */
    WEB_ORDER_SCHEDULE_ALL_BRANCH: 'WEB_ORDER_SCHEDULE_ALL_BRANCH',

    // giao hàng đơn hàng
    WEB_ORDER_SHIP_DETAIL: 'WEB_ORDER_SHIP_DETAIL',
    WEB_ORDER_SHIP_UPDATE: 'WEB_ORDER_SHIP_UPDATE',
    WEB_ORDER_SHIP_DELETE: 'WEB_ORDER_SHIP_DELETE',
    /** Tab Giao hàng — lọc danh sách toàn chi nhánh */
    WEB_ORDER_SHIP_ALL_BRANCH: 'WEB_ORDER_SHIP_ALL_BRANCH',

    // đồng bộ đơn hàng
    WEB_ORDER_SYNC_SYNC: 'WEB_ORDER_SYNC_SYNC',

    // đơn hàng chung
    WEB_ORDER_COMMON_DETAIL: 'WEB_ORDER_COMMON_DETAIL',
    WEB_ORDER_COMMON_QRCODE: 'WEB_ORDER_COMMON_QRCODE',
    WEB_ORDER_COMMON_PRINT: 'WEB_ORDER_COMMON_PRINT',
    WEB_ORDER_COMMON_SPX_PRINT: 'WEB_ORDER_COMMON_SPX_PRINT',

    // tất cả đơn hàng
    WEB_ORDER_ALL_LIST: 'WEB_ORDER_ALL_LIST',
    /** Tab Tất cả đơn — lọc danh sách toàn chi nhánh (API filter-don-hang-all-branch) */
    WEB_ORDER_ALL_ALL_BRANCH: 'WEB_ORDER_ALL_ALL_BRANCH',
    WEB_ORDER_ALL_RESET_ALL: 'WEB_ORDER_ALL_RESET_ALL',
    WEB_ORDER_ALL_OVERRIDE_STATUS: 'WEB_ORDER_ALL_OVERRIDE_STATUS',
    WEB_ORDER_ALL_OVERRIDE_MULTI_STATUS: 'WEB_ORDER_ALL_OVERRIDE_MULTI_STATUS',
    /** Chuyển liên kết workflow giữa các đơn (màn tất cả đơn hàng) */
    WEB_ORDER_ALL_CHANGE_LINK: 'WEB_ORDER_ALL_CHANGE_LINK',

    // quét mã QR
    WEB_ORDER_SCAN_DETAIL: 'WEB_ORDER_SCAN_DETAIL',

    // Hóa đơn
    WEB_INVOICE_LIST: 'WEB_INVOICE_LIST',
    WEB_INVOICE_DETAIL: 'WEB_INVOICE_DETAIL',
    WEB_INVOICE_SYNC: 'WEB_INVOICE_SYNC',

    // Báo cáo
    WEB_REPORT_LIST: 'WEB_REPORT_LIST',
    WEB_REPORT_EXPORT: 'WEB_REPORT_EXPORT',

    // Đồng bộ user
    WEB_SYNC_USER: 'WEB_SYNC_USER',
    /** Đồng bộ Kiot — menu /kho/sync-kiot */
    WEB_SYNC_KIOT: 'WEB_SYNC_KIOT',
    WEB_DUAN_MANGE: 'WEB_DUAN_MANGE',
    /** Cập nhật thông tin chi nhánh (logo, địa chỉ, …) */
    WEB_CHINHANH_MANGE: 'WEB_CHINHANH_MANGE',

} as const; 


export const CHUC_NANG_FILTERS = {
    ORDER_ASSIGN_PICKER: 'ORDER_ASSIGN_PICKER',
    ORDER_ASSIGN_PACKER: 'ORDER_ASSIGN_PACKER',
    ORDER_ASSIGN_SHIPPER: 'ORDER_ASSIGN_SHIPPER',
    ORDER_PICK_UPDATE: 'ORDER_PICK_UPDATE',
    ORDER_PACK_UPDATE: 'ORDER_PACK_UPDATE',
    ORDER_SHIP_UPDATE: 'ORDER_SHIP_UPDATE',
} as const;
